import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { MotionProvider } from "@/motion";
import { AppShell } from "@/components/shell/AppShell";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Matters from "@/pages/Matters";
import MatterDetail from "@/pages/MatterDetail";
import Calendar from "@/pages/Calendar";
import CauseListBoard from "@/pages/CauseListBoard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Documents from "@/pages/Documents";
import Research from "@/pages/Research";
import AISearch from "@/pages/AISearch";
import Drafting from "@/pages/Drafting";
import ReviewDesk from "@/pages/ReviewDesk";
import CrossExam from "@/pages/CrossExam";
import ODR from "@/pages/ODR";
import ODRDetail from "@/pages/ODRDetail";
import ODRJoin, { ODRPortal } from "@/pages/ODRJoin";
import ODRRules from "@/pages/ODRRules";
import Automations from "@/pages/Automations";
import Opportunities from "@/pages/Opportunities";
import ClientPayment from "@/pages/ClientPayment";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Jobs from "@/pages/Jobs";
import PlatformControl, { InternalDenied } from "@/pages/PlatformControl";
import InviteAccept from "@/pages/InviteAccept";

function AppRoutes() {
  const location = useLocation();
  // Synchronously intercept the OAuth callback before any protected route runs.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/pay/:token" element={<ClientPayment />} />
      <Route path="/odr/join/:token" element={<ODRJoin />} />
      <Route path="/odr/portal/:id" element={<ODRPortal />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/internal/platform-control" element={<PlatformControl />} />
      <Route path="/internal/*" element={<InternalDenied />} />
      <Route path="/release-board" element={<InternalDenied />} />
      <Route element={<AppShell />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/matters" element={<Matters />} />
        <Route path="/matters/:id" element={<MatterDetail />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/cause-list" element={<CauseListBoard />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/clients/:id" element={<ClientDetail />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/research" element={<Research />} />
        <Route path="/ai-search" element={<AISearch />} />
        <Route path="/drafting" element={<Drafting />} />
        <Route path="/drafting/:id" element={<Drafting />} />
        <Route path="/review-desk" element={<ReviewDesk />} />
        <Route path="/cross-examination" element={<CrossExam />} />
        <Route path="/odr" element={<ODR />} />
        <Route path="/odr/rules" element={<ODRRules />} />
        <Route path="/odr/:id" element={<ODRDetail />} />
        <Route path="/automations" element={<Automations />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <MotionProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton toastOptions={{ style: { fontFamily: "Inter, sans-serif" } }} />
      </MotionProvider>
    </AppProvider>
  );
}

export default App;
